import React, { useState } from 'react'

import "./Form.css"

import Input from './Input'
import Dropdown from './Dropdown'
import axios from 'axios';

import {ReactComponent as Check} from '../../assets/icons/check.svg'
import {ReactComponent as Error} from '../../assets/icons/error.svg'
import {ReactComponent as Watch} from '../../assets/icons/watch.svg'
import Checkbox from './Checkbox';

const api = axios.create({
  baseURL: '/', 
  headers: {
    'Content-Type': 'application/json'
  }
});

const Form = () => {
    const IDLE = 0;
    const LOAD = 1;
    const SUCCESS = 2;
    const ERROR = 3;
    const TIMEOUT = 4;

    const [form, setForm] = useState({salutation: "", name: "", surname: "", email: "", phone: "", company: "", message: ""})
    const [formStatus, setStatus] = useState(IDLE);

    const handleChange = e => {
        setForm({ ...form, [e.target.id]: e.target.value });
    };

    const submit = async (e) => {
        e.preventDefault()
        setStatus(LOAD)
        try {
            await api.post('/api/contact', form);
            setStatus(SUCCESS);
            setForm({salutation: "", name: "", surname: "", email: "", phone: "", company: "", message: ""})
        } catch (err) {
            if(err.response?.status === 429){
                setStatus(TIMEOUT);
            }else{
                setStatus(ERROR);
            }
        }
    }

    return (
        <>

        {formStatus === IDLE && 
        <form onSubmit={submit}>

            <div className='line'>
                <Dropdown
                    placeholder={"称呼*"}
                    options={["先生", "女士"]}
                    value={form.salutation}
                    onChange={(val) => setForm({ ...form, salutation: val })}
                    required
                />

                <Input id="name" label="名" required value={form.name} onChange={handleChange}/>
            </div>

            <div className='line'>
                <Input id="surname" label="姓" required value={form.surname} onChange={handleChange}/>
                <Input id="email" type="email" label="电子邮件" required value={form.email} onChange={handleChange}/>
            </div>

            <div className='line'>
                <Input id="phone" type="tel" label="电话号码" value={form.phone} onChange={handleChange}/>
                <Input id="company" label="公司" value={form.company} onChange={handleChange}/>
            </div>

            <div className="message-wrapper">
                <label className="message-label" htmlFor="message"> <span className={form.message.length > 1000 ? "disabled" : ""}>{form.message.length}</span> / 1000</label>
                <textarea id="message" placeholder={"消息"} value={form.message} onChange={handleChange}></textarea>
            </div>

            <div className='consent-wrapper'>
                <Checkbox id={"consent"} required/>
                <label htmlFor='consent'>您是否同意存储您的数据并将其用于处理您的请求？*</label>
            </div>
            <p>*此为必填字段</p>
            
            <button className='submit btn filled' type='submit' disabled={form.message.length > 1000}> 发送 <span>→</span></button>
        </form>
        }

        {formStatus === LOAD && 
            <div className='loading'>
                <div/>
                <h2>正在发送请求...</h2>
            </div>
        }

        {formStatus > LOAD && 
            <div className='response'>
                <div>
                    {formStatus === SUCCESS && <Check/>}
                    {formStatus === ERROR && <Error/>}
                    {formStatus === TIMEOUT && <Watch/>}
                </div>

                {formStatus === SUCCESS && <h2> 请求已成功发送。 <br/> 我们将与您联系！ </h2>}
                {formStatus === ERROR && <h2> 發生錯誤。<br/> 请稍后重试。</h2>}
                {formStatus === TIMEOUT && <h2> 发送的请求过多。 <br/> 请稍后重试。</h2>}

                <button id='filled-btn' onClick={() => setStatus(IDLE)}><span>←</span> 后退 </button>
            </div>
        }

        </>
    )
}

export default Form
